import styled, { css } from "styled-components";

import {
  ACCENT_PRIMARY_LIGHTEST,
  ACCENT_PRIMARY_LIGHTEST_HOVER,
  ACCENT_PRIMARY_LIGHTEST_PRESSED,
  ACCENT_SECONDARY_LIGHTEST,
  ACCENT_SECONDARY_LIGHTEST_HOVER,
  ACCENT_SECONDARY_LIGHTEST_PRESSED,
  GRAY,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  GRAY_LIGHTEST_HOVER,
  GRAY_LIGHTEST_PRESSED,
  TEXT_SECONDARY,
  WHITE
} from "../../colors";
import { Body, Caption, SecondaryLarge } from "../../typography";
import {
  PseudoButton as PseudoButtonBase,
  PseudoLink as PseudoLinkBase
} from "../atoms";
import calloutCardThemes from "../constants/calloutCardThemes";
import imagePositions from "../constants/imagePositions";

const themeStyles = {
  [calloutCardThemes.BLUE]: css`
    background: ${ACCENT_PRIMARY_LIGHTEST};
  `,
  [calloutCardThemes.ORANGE]: css`
    background: ${ACCENT_SECONDARY_LIGHTEST};
  `,
  [calloutCardThemes.GRAY]: css`
    background: ${GRAY_LIGHTEST};
  `,
  [calloutCardThemes.WHITE]: css`
    background: ${WHITE};
    border-color: ${GRAY_LIGHT};
  `
};

const interactiveThemeStyles = {
  [calloutCardThemes.BLUE]: css`
    &:hover {
      background: ${ACCENT_PRIMARY_LIGHTEST_HOVER};
    }

    &:active {
      background: ${ACCENT_PRIMARY_LIGHTEST_PRESSED};
    }
  `,
  [calloutCardThemes.ORANGE]: css`
    &:hover {
      background: ${ACCENT_SECONDARY_LIGHTEST_HOVER};
    }

    &:active {
      background: ${ACCENT_SECONDARY_LIGHTEST_PRESSED};
    }
  `,
  [calloutCardThemes.GRAY]: css`
    &:hover {
      background: ${GRAY_LIGHTEST_HOVER};
    }

    &:active {
      background: ${GRAY_LIGHTEST_PRESSED};
    }
  `,
  [calloutCardThemes.WHITE]: css`
    &:hover {
      background: ${WHITE};
    }
  `
};

export const VerticalCardWrapper = styled.span`
  align-items: flex-start;
  border: 1px solid transparent;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  cursor: ${({ interactive }) => (interactive ? "pointer" : "default")};
  display: flex;
  flex-direction: column;
  padding: 20px;
  text-align: left;
  text-decoration: none;
  transition: background 250ms, box-shadow 250ms;
  width: 100%;

  ${({ theme }) => themeStyles[theme]}

  ${({ interactive, theme }) =>
    interactive &&
    css`
      &:hover {
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
      }

      &:active {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
      }

      ${interactiveThemeStyles[theme]}
    `}
`;

export const IllustrationWrapper = styled.span`
  margin-bottom: 16px;
  order: ${({ imagePosition }) =>
    imagePosition === imagePositions.TOP ? 0 : 2};
`;

export const StaticIllustrationWrapper = styled(IllustrationWrapper)`
  margin: ${({ imagePosition, legalCopy }) =>
    imagePosition === imagePositions.BOTTOM && !legalCopy
      ? "16px 0 0"
      : "0 0 16px"};
`;

export const Separator = styled.span`
  background-color: ${({ theme }) =>
    theme === calloutCardThemes.WHITE ? GRAY_LIGHT : GRAY};
  border: none;
  height: 1px;
  margin: 18px 0 0;
  order: 4;
  width: 100%;
`;

export const ContentWrapper = styled.span`
  margin-bottom: 16px;
  order: 1;

  & + ${Separator} {
    margin-top: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Headline = styled(SecondaryLarge).attrs({
  as: "span"
})`
  display: block;
  margin-bottom: 8px;
`;

export const Description = styled(Body).attrs({
  as: "span"
})`
  display: block;
`;

export const PseudoLink = styled(PseudoLinkBase)`
  margin-top: 0;
  order: 3;
`;

export const PseudoButton = styled(PseudoButtonBase)`
  box-sizing: border-box;
  line-height: 38px;
  order: 3;
  width: 100%;
`;

export const LegalCopy = styled(Caption).attrs({
  as: "span"
})`
  color: ${TEXT_SECONDARY};
  margin-top: 16px;
  order: 5;
`;
